var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g4, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineCompliance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3345_19874)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000112568 40.61L45.8799 40.61C45.8799 52.4369 36.4873 62.0287 24.9024 62.0287L23.548 62.0287L19.6015 61.9612C8.65936 61.2347 -0.00249393 51.9662 -0.000112568 40.61Z",
    fill: "#3388FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.27002 22.4248L33.7851 61.4799C34.0188 61.7136 34.336 61.8443 34.6665 61.8431L60.8544 61.7478C61.5374 61.7453 62.0899 61.1909 62.0899 60.5078L62.0899 37.9899C62.0899 37.1677 61.7633 36.3792 61.1819 35.7979L21.044 -4.34003",
    fill: "#003C8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.1C0 1.38792 1.38792 0 3.1 0H24.8C41.9208 0 55.8 13.8792 55.8 31V37.51C55.8 39.2221 54.4121 40.61 52.7 40.61H0V3.1Z",
    fill: "#1760CE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3345_19874)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3345_19874)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27563 39.7445V9.34627C7.27563 8.12011 8.26029 7.13 9.47971 7.13H49.2769C50.4898 7.13 51.4744 8.12011 51.4744 9.34627V39.7445C51.4744 40.9641 50.4898 41.9608 49.2769 41.9608H9.47971C8.26029 41.9608 7.27563 40.9641 7.27563 39.7445Z",
    fill: "#DAEAFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3345_19874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 45,
    height: 32
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4743 38.2289V8.65385C51.4743 7.81225 50.7921 7.13 49.9505 7.13H9.45434C8.62636 7.13 7.93342 7.61661 7.57897 8.22027C7.47706 8.39384 7.5488 8.60879 7.71569 8.72132L51.4743 38.2289Z",
    fill: "#3388FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3345_19874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27563 39.7445V9.34627C7.27563 8.12011 8.26029 7.13 9.47971 7.13H49.2769C50.4898 7.13 51.4744 8.12011 51.4744 9.34627V39.7445C51.4744 40.9641 50.4898 41.9608 49.2769 41.9608H9.47971C8.26029 41.9608 7.27563 40.9641 7.27563 39.7445Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3345_19874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 20,
    width: 51,
    height: 31
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5246 37.4601V33.9242C30.5641 33.9242 30.6036 33.9176 30.643 33.9176H31.5837C33.1426 33.9176 34.4122 35.1795 34.4122 36.7371V40.5556L35.2936 41.4363V36.6714C35.2936 36.5991 35.3002 36.5268 35.3068 36.4545V22.7711C35.3068 21.713 36.1619 20.8586 37.221 20.8586C38.28 20.8586 39.1352 21.713 39.1352 22.7711V31.8474C39.4377 31.7816 39.7403 31.7356 40.0561 31.7225V28.673C40.0561 27.6148 40.9112 26.7605 41.9702 26.7605C43.0227 26.7605 43.8844 27.6148 43.8844 28.673V31.7094H44.8053V30.4146C44.8053 29.3631 45.6671 28.5021 46.7195 28.5021C47.7786 28.5021 48.6337 29.3565 48.6337 30.4146V31.7225C48.956 31.7422 49.2652 31.7882 49.5678 31.8671C49.8046 31.0784 50.5347 30.5001 51.3965 30.5001C52.4555 30.5001 53.3106 31.3544 53.3106 32.4126V36.6714V41.4231V44.7421C53.3106 46.4114 52.4884 47.8836 51.2254 48.784L38.951 49.5201C38.1485 49.3032 37.4249 48.8892 36.8394 48.3305L30.5049 42.1395V37.4535C30.5115 37.4535 30.518 37.4535 30.5246 37.4601Z",
    fill: "#EDF4FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71997 32.5618L4.89742 29.9066H4.86453L6.09461 27.1988L7.18655 24.7276L7.21286 24.7408L7.23917 24.6816L15.0538 24.7999C15.0538 24.8525 15.0604 24.9051 15.0604 24.9642L15.0406 26.2656C15.0077 28.4212 13.2317 30.1366 11.0741 30.1037L10.219 30.0774L9.00864 33.7053C11.4622 35.5127 13.1199 38.9697 13.1199 42.9327C13.1199 45.9757 12.1397 48.7163 10.5742 50.6486H3.74628V32.5749L3.71997 32.5618Z",
    fill: "#EDF4FC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3345_19874)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.34888,
    y: 4.60571,
    width: 30.9392,
    height: 24.3815,
    rx: 1.52923,
    fill: "#AFD0FE"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.12 11.1157H11.2485V38.13H47.12V11.1157Z",
    fill: "#5C656F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3345_19874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 37,
    height: 28
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.12 11.1158H11.2485V38.1301H47.12V11.1158Z",
    fill: "#D8DDE1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3345_19874)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3345_19874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0464 45.9384H16.8533C16.4481 45.9384 16.1199 45.5883 16.1199 45.1559V14.1491C16.1199 13.7168 16.4481 13.3666 16.8533 13.3666H42.0464C42.4517 13.3666 42.7799 13.7168 42.7799 14.1491V45.1559C42.7799 45.5883 42.4517 45.9384 42.0464 45.9384Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.0464 13.3666H16.8533C16.4481 13.3666 16.1199 13.7168 16.1199 14.1491V19.3089H42.7799V14.1491C42.7799 13.7168 42.4517 13.3666 42.0464 13.3666Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5684 15.9495H27.4709V16.8227H40.5684V15.9495Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5044 21.3783H33.0618V22.2685H40.5044V21.3783Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5044 29.0185H33.0618V29.9087H40.5044V29.0185Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M42.008 46.0194C42.4195 46.0194 42.7527 45.6679 42.7527 45.234V14.1154C42.7527 13.6815 42.4195 13.33 42.008 13.33L29.2173 13.33V46.0194C33.4809 46.0194 37.7444 46.0194 42.008 46.0194Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4137 14.0658C21.8913 14.9208 22.481 16.0332 23.3082 17.6956C23.3405 17.7603 23.3207 17.8518 23.2573 17.8864C22.7986 18.1367 22.1761 18.4805 21.0305 18.8808C21.0166 18.8857 21.001 18.8826 20.9864 18.8805C20.921 18.8719 20.6504 18.8305 20.4752 18.7841C20.422 18.77 20.3725 18.7445 20.3458 18.6963L18.5429 15.449C18.5126 15.3943 18.5139 15.3275 18.5466 15.2742L18.7965 14.8652L21.2086 13.9954C21.285 13.968 21.3742 13.9949 21.4137 14.0658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3013 14.4259L21.981 15.6808L20.0382 16.4731L19.3404 15.1604L21.3013 14.4259Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.019 15.2613C19.019 15.2613 19.7019 16.5218 20.614 18.1787C20.6139 18.1787 19.9426 17.1257 19.019 15.2613Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1872 16.8341L21.6664 16.6334C21.7041 16.6176 21.72 16.5726 21.7002 16.5368L21.5598 16.2806C21.543 16.2501 21.5061 16.2368 21.4738 16.2499L20.9905 16.4435C20.9522 16.4588 20.9359 16.5044 20.9557 16.5406L21.1 16.8039C21.1172 16.8345 21.1548 16.8477 21.1872 16.8341Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8753 16.546L22.2644 16.383C22.3013 16.3676 22.3173 16.3236 22.299 16.288L22.1706 16.0379C22.1543 16.0063 22.1168 15.9922 22.0837 16.0054L21.6834 16.1658C21.645 16.1813 21.6287 16.2268 21.6488 16.2632L21.7885 16.5158C21.8054 16.5465 21.8429 16.5596 21.8753 16.546Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7826 16.5266L20.2695 16.7321C20.2311 16.7475 20.2149 16.793 20.2348 16.8294L20.3852 17.1033C20.4022 17.1342 20.4397 17.1472 20.4722 17.1336L20.9809 16.9206C21.0186 16.9048 21.0344 16.8597 21.0146 16.8239L20.8687 16.5576C20.8519 16.5269 20.815 16.5137 20.7826 16.5266Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3051 17.5118L20.796 17.725C20.7635 17.7386 20.726 17.7255 20.709 17.6946L20.5581 17.4192C20.5384 17.3833 20.5543 17.3381 20.5921 17.3224L21.102 17.1109C21.1345 17.0975 21.1719 17.1106 21.1887 17.1414L21.3387 17.4152C21.3587 17.451 21.3429 17.496 21.3051 17.5118Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9904 17.2246L21.5111 17.4253C21.4786 17.4389 21.4411 17.4259 21.4241 17.3949L21.2745 17.1219C21.2549 17.0859 21.2707 17.0408 21.3085 17.025L21.7886 16.8259C21.8211 16.8124 21.8585 16.8256 21.8753 16.8564L22.0241 17.128C22.0439 17.1638 22.0282 17.2088 21.9904 17.2246Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1983 17.1378L22.5959 16.9712C22.6336 16.9555 22.6493 16.9106 22.6298 16.8748L22.483 16.6047C22.4662 16.5737 22.4287 16.5605 22.3962 16.574L21.997 16.7395C21.9592 16.7552 21.9433 16.8003 21.963 16.8363L22.1113 17.1074C22.1283 17.1382 22.1658 17.1513 22.1983 17.1378Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5029 17.6912L22.897 17.5167C22.9337 17.5005 22.9489 17.4563 22.9296 17.4209L22.7998 17.1816C22.783 17.1506 22.7457 17.1374 22.7132 17.1506L22.312 17.3146C22.2739 17.3302 22.2579 17.3755 22.2776 17.4115L22.4146 17.6614C22.4319 17.6927 22.4703 17.7058 22.5029 17.6912Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4138 17.6815L20.8874 17.8965C20.8482 17.9125 20.8326 17.9598 20.8546 17.996L21.0263 18.2793C21.0441 18.3089 21.0814 18.3207 21.113 18.3066L21.6135 18.0849C21.65 18.0687 21.6652 18.0251 21.6466 17.9897L21.5008 17.7129C21.4841 17.6817 21.4466 17.668 21.4138 17.6815Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8236 17.9921L22.2979 17.782C22.3347 17.7658 22.3498 17.7213 22.3304 17.6859L22.1903 17.4303C22.1735 17.3997 22.1362 17.3864 22.1038 17.3997L21.6224 17.5964C21.5843 17.612 21.5683 17.6573 21.5879 17.6934L21.7352 17.9622C21.7526 17.9936 21.7908 18.0066 21.8236 17.9921Z",
    fill: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4355 21.4067H18.521V22.2799H29.4355V21.4067Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8162 21.8434L31.182 21.8434M31.182 21.8434L28.9991 19.6605M31.182 21.8434L28.9991 24.0263",
    stroke: "#BDC3C7",
    strokeWidth: 0.873162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4355 29.0469H18.521V29.9201H29.4355V29.0469Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8162 29.4836L31.182 29.4836M31.182 29.4836L28.9991 27.3007M31.182 29.4836L28.9991 31.6665",
    stroke: "#BDC3C7",
    strokeWidth: 0.873162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8162 38.6517L31.182 38.6517M31.182 38.6517L28.9991 36.4688M31.182 38.6517L28.9991 40.8346",
    stroke: "#BDC3C7",
    strokeWidth: 0.873162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4743 38.2289V8.65385C51.4743 7.81225 50.7921 7.13 49.9505 7.13H9.46232C8.52056 7.13 7.74241 7.75198 7.43115 8.52946L51.4743 38.2289Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7259 41.9608H6.03052V71.1937H19.7259V41.9608Z",
    fill: "#DEC1AE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7343 39.2223V35.6864C33.7738 35.6864 33.8133 35.6798 33.8527 35.6798H34.7934C36.3524 35.6798 37.6219 36.9417 37.6219 38.4993V42.3178L38.5033 43.1985V38.4336C38.5033 38.3613 38.5099 38.289 38.5165 38.2167V24.5333C38.5165 23.4752 39.3716 22.6208 40.4307 22.6208C41.4897 22.6208 42.3449 23.4752 42.3449 24.5333V33.6096C42.6475 33.5439 42.95 33.4978 43.2658 33.4847V30.4352C43.2658 29.3771 44.1209 28.5227 45.18 28.5227C46.2324 28.5227 47.0941 29.3771 47.0941 30.4352V33.4716H48.0151V32.1768C48.0151 31.1253 48.8768 30.2643 49.9292 30.2643C50.9883 30.2643 51.8434 31.1187 51.8434 32.1768V33.4847C52.1657 33.5044 52.4749 33.5504 52.7775 33.6293C53.0143 32.8406 53.7445 32.2623 54.6062 32.2623C55.6652 32.2623 56.5204 33.1167 56.5204 34.1748V38.4336V43.1853V46.5043C56.5204 48.1737 55.6981 49.6458 54.4351 50.5462V94.4422H42.1607V51.2823C41.3582 51.0654 40.6346 50.6514 40.0492 50.0928L33.7146 43.9017V39.2157C33.7212 39.2157 33.7278 39.2157 33.7343 39.2223Z",
    fill: "#DEC1AE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03035 34.4048L7.21575 31.7496H7.18264L8.42103 29.0418L9.52034 26.5707L9.54683 26.5838L9.57332 26.5247L17.4407 26.643C17.4407 26.6955 17.4473 26.7481 17.4473 26.8073L17.4275 28.1086C17.3944 30.2643 15.6063 31.9796 13.4342 31.9468L12.5733 31.9205L11.3547 35.5483C13.8249 37.3557 15.4937 40.8127 15.4937 44.7758C15.4937 47.8187 14.4541 52.1406 12.878 54.0728H6.03027L6.03035 34.4048Z",
    fill: "#EFD0BB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.02 54.0729H5.49146V132.459H13.02V54.0729Z",
    fill: "#3388FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5486 54.0729H13.02V132.459H20.5486V54.0729Z",
    fill: "#1760CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3345_19874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 23,
    width: 11,
    height: 81
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2791 23.5146H48.3618V103.526H58.2791V23.5146Z",
    fill: "#3388FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3345_19874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5402 39.2223V35.6864C33.5799 35.6864 33.6197 35.6798 33.6595 35.6798H34.6076C36.1789 35.6798 37.4585 36.9417 37.4585 38.4993V42.3178L38.347 43.1985V38.4336C38.347 38.3613 38.3536 38.289 38.3602 38.2167V24.5333C38.3602 23.4752 39.2221 22.6208 40.2896 22.6208C41.357 22.6208 42.2189 23.4752 42.2189 24.5333V33.6096C42.5239 33.5439 42.8289 33.4978 43.1471 33.4847V30.4352C43.1471 29.3771 44.009 28.5227 45.0765 28.5227C46.1373 28.5227 47.0058 29.3771 47.0058 30.4352V33.4716H47.934V32.1768C47.934 31.1253 48.8026 30.2643 49.8634 30.2643C50.9308 30.2643 51.7927 31.1187 51.7927 32.1768V33.4847C52.1176 33.5044 52.4292 33.5504 52.7342 33.6293C52.9729 32.8406 53.7088 32.2623 54.5774 32.2623C55.6448 32.2623 56.5067 33.1167 56.5067 34.1748V38.4336V43.1853V46.5043C56.5067 48.1737 55.678 49.6458 54.405 50.5462V94.4422H42.0333V51.2823C41.2244 51.0654 40.4951 50.6514 39.905 50.0928L33.5203 43.9017V39.2157C33.5269 39.2157 33.5335 39.2157 33.5402 39.2223Z",
    fill: "#EFD0BB"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4485 54.0729H41.3628V132.459H48.4485V54.0729Z",
    fill: "#1760CE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9771 54.0729H48.4485V132.459H55.9771V54.0729Z",
    fill: "#3388FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3345_19874",
    x: 1.24888,
    y: 7.13,
    width: 55.2714,
    height: 127.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.1,
    dy: 2.17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3345_19874"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3345_19874",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3345_19874",
    x: 3.10888,
    y: 7.13,
    width: 54.6514,
    height: 127.809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.62
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3345_19874"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3345_19874",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3345_19874",
    x: 15.3714,
    y: 13.3666,
    width: 27.4083,
    height: 33.3203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.748425,
    dy: 0.748425
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3345_19874"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3345_19874",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3345_19874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineCompliance);
export default __webpack_public_path__ + "static/media/machine_compliance.597a68bc.svg";
export { ForwardRef as ReactComponent };